import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
  httpGetCredentials,
  httpSearchPrincipal,
  httpUpdateUserSettings,
} from 'api';
import { redirectToAuth, showErrorMessage, getErrorText } from 'helpers';

const getCredentials = createAsyncThunk(
  'user/getCredentials',
  async (sessionId) => {
    try {
      const { data } = await httpGetCredentials({
        data: { sessionId, type: 'email' },
      });

      return data;
    } catch (error) {
      redirectToAuth();
      throw error;
    }
  },
);

const getPrincipal = createAsyncThunk('template/getPrincipal', async () => {
  try {
    const body = {
      criteria: [
        {
          key: 'email',
          value: '@amdtelecom.net',
          operation: 'CONTAINS',
          operator: 'OR',
        },
        {
          key: 'email',
          value: '@waymore.io',
          operation: 'CONTAINS',
          operator: 'OR',
        },
      ],
    };

    const { data } = await httpSearchPrincipal(body);

    return { data };
  } catch (error) {
    showErrorMessage(getErrorText());
    throw error;
  }
});

const setTheme = createAction('setTheme');

const updateUserSettings = createAsyncThunk(
  'blocks/updateUserSettings',
  async (payload) => {
    try {
      const { data } = await httpUpdateUserSettings(payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

export { getCredentials, getPrincipal, setTheme, updateUserSettings };
